var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['content', {'show': !_vm.isTop && _vm.show}]},[_c('base-button',{attrs:{"padding":"16px","background":"var(--white-color)"},on:{"click":function($event){return _vm.up()}}},[_c('svg',{attrs:{"width":"24px","height":"24px","fill":"#bbb"}},[_c('use',{attrs:{"xlink:href":require("../../assets/images/sprite.svg") + "#angle"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }